import { first } from 'lodash';
import { StringEnum } from 'utils/enum';

export const useShareId = (): string => {
  const shareIdsArray = window.location.pathname.split('-').splice(-1);
  const shareId = first(shareIdsArray);

  return shareId ?? StringEnum.EMPTY;
};
